import React from 'react';
import { createSvgIcon } from '../IconBase';

export default createSvgIcon(<path d="M8 5v14l11-7z" />, 'PlayArrow');
